const categories = [
  {
    value: "C",
    label: "C++"
  },
  {
    value: "PYTHON",
    label: "Python"
  },
  {
    value: "JAVASCRIPT",
    label: "Javascript"
  },
  {
    value: "JAVA",
    label: "Java"
  },
  {
    value: "PHP",
    label: "Php"
  },
  {
    value: "REACT_NATIVE",
    label: "React Native"
  },
  {
    value: "REACT_JS",
    label: "React.js"
  },
  {
    value: "NODE_JS",
    label: "Node.js"
  },
  {
    value: "ANGULAR",
    label: "Angular +2"
  },
  {
    value: "SQL",
    label: "Sql"
  }
];

export default categories;
